<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container modal-container-80" style="width: 700px" :style="{maxHeight: getMaxHeightClient() + 'px'}" @mousedown.stop="">
          <div class="modal-body m-4">
            <div v-if="isPopupActive">
            <b-row class="justify-content-start">
              <b-col cols="1" class="mr-0 pr-0">
                <i class="fa-solid fa-file" style="font-size: 20px"></i>
              </b-col>
              <b-col cols="4" class="pl-0">
                <b style="font-size: 16px"> Nom du fichier </b>
              </b-col>
            </b-row>
            <b-row class="justify-content-center">
              <b-col sm="12">
                <hr />
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12" class="bandeaupp1 mb-3">
                <span> 200 lignes acceptées </span>
                <i class="fa-solid fa-check"></i>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12" class="bandeaupp2 mb-3">
                <span> 150 lignes en erreur </span>
                <i class="fa-solid fa-xmark"></i>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12" class="bandeaupp3 mb-3">
                <span> 150 lignes en attente de décision </span>
                <i class="fa-solid fa-pencil"></i>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12" class="text-right">
                <b> Total de 500 lignes </b>
              </b-col>
            </b-row>
          </div>
            <b-row class="justify-content-center mt-3">
              <b-col sm="4" class="mt-3">
                <b-button class="btn" @click="importOtherFile()">
                  Importer un autre fichier
                </b-button>
              </b-col>
              <b-col sm="4" class="mt-3">
                <b-button class="btn">
                  Consulter ce lot
                </b-button>
              </b-col>
              <b-col sm="4" class="mt-3">
                <b-button class="btn">
                  Configurer mes règles d'acceptance
                </b-button>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import backButton from '@/components/common/backButton.vue'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'importFilePopup',
  components: {
    'back-button': backButton
  },
  props: {
    devisFormData: {
      type: Object
    }
  },
  data: () => {
    return {
      isPopupActive: true,
    }
  },
  created () {
    window.addEventListener('resize', this.changeMaxHeightClient)
  },
  destroyed () {
    window.removeEventListener('resize', this.changeMaxHeightClient)
  },
  methods: {
    changeMaxHeightClient () {
      let maxHeight = document.querySelector('body').clientHeight - 50
      document.querySelector('.modal-container').setAttribute('style', 'overflow-y:auto;max-height:' + maxHeight + 'px')
    },
    getMaxHeightClient () {
      return document.querySelector('body').clientHeight - 50
    },
    importOtherFile () {
      this.isPopupActive = false
      this.$emit('close')
    }
  }
}
</script>
